import configureStore from '../store';
const store = configureStore();

export { store }
//reason of exporting 'store':
//some store's functions such as 'disptach()' can be used from
//non-react components
